<template> 

    <router-view :key="$route.path" />

</template>

<script>

import {useDataProvider} from "@/composable/plans"
import {loadJsonData} from "@/composable/dataProvider";
import {getSelectedData} from "@/composable/selectedData"

export default {
  setup() {
    useDataProvider();
    loadJsonData(); 
    getSelectedData();
  },

};
</script>

<style>
@import './assets/animate.css';
@import './assets/header.css';
@import './assets/layout.css';
@import './assets/reset.css';
</style>

